var _g, _rect, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGame2048Logo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 350,
    viewBox: "0 0 350 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_126_122)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 50,
    width: 250,
    height: 250,
    fill: "#D9D9D9",
    fillOpacity: 0.01
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 55,
    width: 240,
    height: 240,
    stroke: "#171717",
    strokeOpacity: 0.3,
    strokeWidth: 10,
    strokeDasharray: "40 40"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_126_122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.103 124H159.616L164.744 129.128L159.616 134.256H139.103L133.974 129.128L139.103 124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.103 216.308H159.616L164.744 221.436L159.616 226.564H139.103L133.974 221.436L139.103 216.308Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.539 136.821L136.539 167.59L131.41 172.718L126.282 167.59L126.282 136.821L131.41 131.692L136.539 136.821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.436 136.821L172.436 167.59L167.308 172.718L162.179 167.59L162.179 136.821L167.308 131.692L172.436 136.821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.539 182.974L136.539 213.744L131.41 218.872L126.282 213.744L126.282 182.974L131.41 177.846L136.539 182.974Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.436 182.974L172.436 213.744L167.308 218.872L162.179 213.744L162.179 182.974L167.308 177.846L172.436 182.974Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.385 170.154H210.898L216.026 175.282L210.898 180.41H190.385L185.257 175.282L190.385 170.154Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.821 136.821L187.821 167.59L182.692 172.718L177.564 167.59L177.564 136.821L182.692 131.692L187.821 136.821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.718 136.821L223.718 167.59L218.59 172.718L213.462 167.59L213.462 136.821L218.59 131.692L223.718 136.821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.718 182.974L223.718 213.744L218.59 218.872L213.462 213.744L213.462 182.974L218.59 177.846L223.718 182.974Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.667 124H262.18L267.308 129.128L262.18 134.256H241.667L236.539 129.128L241.667 124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.667 170.154H262.18L267.308 175.282L262.18 180.41H241.667L236.539 175.282L241.667 170.154Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.667 216.308H262.18L267.308 221.436L262.18 226.564H241.667L236.539 221.436L241.667 216.308Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.103 136.821L239.103 167.59L233.974 172.718L228.846 167.59L228.846 136.821L233.974 131.692L239.103 136.821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 136.821L275 167.59L269.872 172.718L264.744 167.59L264.744 136.821L269.872 131.692L275 136.821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.103 182.974L239.103 213.744L233.974 218.872L228.846 213.744L228.846 182.974L233.974 177.846L239.103 182.974Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 182.974L275 213.744L269.872 218.872L264.744 213.744L264.744 182.974L269.872 177.846L275 182.974Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8201 124H108.333L113.461 129.128L108.333 134.256H87.8201L82.6919 129.128L87.8201 124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8201 170.154H108.333L113.461 175.282L108.333 180.41H87.8201L82.6919 175.282L87.8201 170.154Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8201 216.308H108.333L113.461 221.436L108.333 226.564H87.8201L82.6919 221.436L87.8201 216.308Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.154 136.821L121.154 167.59L116.026 172.718L110.897 167.59L110.897 136.821L116.026 131.692L121.154 136.821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2564 182.974L85.2564 213.744L80.1282 218.872L75 213.744L75 182.974L80.1282 177.846L85.2564 182.974Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_126_122",
    x: 40,
    y: 40,
    width: 270,
    height: 270,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.654902 0 0 0 0 0.545098 0 0 0 0 0.980392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_126_122"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -10,
    dy: -10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.654902 0 0 0 0 0.545098 0 0 0 0 0.980392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_126_122",
    result: "effect2_innerShadow_126_122"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_126_122",
    x: 65,
    y: 114,
    width: 220,
    height: 122.564,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.654902 0 0 0 0 0.545098 0 0 0 0 0.980392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_126_122"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_126_122",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGame2048Logo);
export default __webpack_public_path__ + "static/media/Game 2048 Logo.abe5d713ff53e91614e1d2f9812d0f4d.svg";
export { ForwardRef as ReactComponent };